import { NgClass } from '@angular/common';
import { Component, computed, inject, input, output, signal, viewChild } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { AppService } from '@core';
import { SelectErrorState } from '@ui';

import { LocationData } from '../../../models';
import { LocationService } from '../../../services';

@Component({
  imports: [
    MatSelectModule,
    MatIconModule,
    NgClass,
    MatExpansionModule,
  ],
  selector: 'avs-location-selector',
  templateUrl: './location-selector.component.html',
})
export class LocationSelectorComponent extends SelectErrorState {
  changed = output<string | null>();
  panelClosed = output<void>();
  value = input<string>();
  cssClass = input<string>();
  disabled = input<boolean>();
  displayType = input<'select' | 'panel' | 'filter'>('select');
  required = input<boolean>(false);
  hasError = input<boolean>(false);

  protected select = viewChild(MatSelect);
  protected appService = inject(AppService);
  protected locationService = inject(LocationService);
  protected locations = signal<LocationData[]>([]);
  protected selectedLocation = computed(() => this.locations()
    .find(location => location.id === this.value()) || null,
  );

  constructor() {
    super();

    this.locationService.getLocationsList(false)
      .subscribe(locations => this.locations.set(locations));
  }

  protected valueChanged($event: string) {
    this.changed.emit($event);
  }

  protected onPanelChange(isOpen: boolean) {
    if (!isOpen) {
      this.panelClosed.emit();
    }
  }

  protected onBlur() {
    this.panelClosed.emit();
  }
}
